export interface AdobeLaunchConfig {
    url: string;
    disabled: boolean;
}

export const adobeLaunchScriptLoader = (config: AdobeLaunchConfig) => {
    const existingScript = document.getElementById(
        'adobeLaunchScript',
    ) as HTMLScriptElement;
    if (existingScript) {
        if (config.disabled) {
            document.head.removeChild(existingScript);
        } else {
            existingScript.setAttribute('src', config.url);
        }
    } else if (!config.disabled) {
        const script = document.createElement('script');
        script.id = 'adobeLaunchScript';
        script.setAttribute('src', config.url);
        script.async = true;
        document.head.appendChild(script);
    }
};
